import { render, staticRenderFns } from "./TableCustomerDetails.template.vue?vue&type=template&id=076e400d&scoped=true&"
var script = {}
import style0 from "./TableCustomerDetails.template.vue?vue&type=style&index=0&id=076e400d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e400d",
  null
  
)

export default component.exports